import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { processDataReports } from 'eflex/constants/bi-report-options';
import moment from 'moment-timezone';

export default class BiProcessDataController extends Controller {
  @tracked searchTerm;
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked selectedToken;
  @tracked isNumericSearch = false;
  @tracked refresher = false;
  queryParams = ['searchTerm', 'isNumericSearch', 'beginDate', 'endDate'];
  selectedReport = processDataReports.processDataLookup;

  get reportOptions() {
    return Object.values(processDataReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      searchTerm: '',
      isNumericSearch: false,
      beginDate: null,
      endDate: null,
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
}
